import { render, staticRenderFns } from "./InvPF_Details.vue?vue&type=template&id=00eefa88"
import script from "./InvPF_Details.vue?vue&type=script&lang=js"
export * from "./InvPF_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports